import _ from 'lodash';
import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import type { UserInfo } from 'bundles/teams-v2/common/types';

const SERIALIZED_PROPS: Array<keyof PaymentFormStore$DehydratedState> = ['userInfo'];

type PaymentFormStore$DehydratedState = {
  userInfo: UserInfo;
};

class TeamsUserSignupStore extends BaseStore {
  userInfo!: UserInfo;

  emitChange!: () => void;

  static storeName = 'TeamsUserSignupStore';

  static handlers = {
    UPDATE_USER_INFO: 'onUpdateUserInfo',
  };

  onUpdateUserInfo(fields: UserInfo) {
    this.userInfo = Object.assign({}, this.userInfo, fields);
    this.emitChange();
  }

  dehydrate(): PaymentFormStore$DehydratedState {
    return _.pick(this, ...SERIALIZED_PROPS);
  }

  rehydrate(state: PaymentFormStore$DehydratedState) {
    Object.assign(this, _.pick(state, ...SERIALIZED_PROPS));
  }

  initialize() {
    this.userInfo = {};
  }

  getUserInfo(): UserInfo {
    return this.userInfo;
  }
}

export default TeamsUserSignupStore;
